//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { useGetClientRetailersQuery } from '@campaigns/components/campaign-requests/sampling-campaigns/SamplingCampaignsQueries';
import { CampaignRequestRetailerField } from '@campaigns/components/campaigns-overview/create-campaign-modal/CampaignRequestRetailerField';
import { transformRetailersToDropdownOptions } from '@campaigns/utils/sampling/clientRetailerUtils';
import {
  BodyBoldText,
  BodyText,
  CaptionText,
} from '@components/atoms/text/Text';

export const PrepaidRetailerSelectionModal = () => {
  const { data: retailers = [] } = useGetClientRetailersQuery(
    transformRetailersToDropdownOptions,
  );

  return (
    <Container>
      <BodyText>
        Choose where you expect to see reviews collected from this campaign. You
        will still be able to see content and reporting on this campaign.
      </BodyText>
      <RetailerSection>
        <BodyText>Where should this content appear?</BodyText>
        <BodyBoldText>Chosen Retailer</BodyBoldText>
        <CaptionText>
          Content will be sent only to one retailer and will not appear on your
          site.
        </CaptionText>
        <DropdownContainer>
          <CampaignRequestRetailerField
            retailerOptions={retailers}
            shouldShowCheckbox={false}
          />
        </DropdownContainer>
      </RetailerSection>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacings[3]};
  padding-right: ${({ theme }) => theme.spacings[4]};
`;

const RetailerSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings[2]};
`;

const DropdownContainer = styled.div`
  width: ${({ theme }) => theme.smallMeasure};
`;
